import { useTranslation } from 'react-i18next'

import Card from 'js/components/Card'
import EventActions from 'js/events/EventActions/EventActions'
import EventAttend from 'js/events/EventAttend/EventAttend'
import { EventAttendees } from 'js/events/EventAttendees/EventAttendees'
import type { SiteStoreState } from 'js/lib/stores/SiteStore'

import type { EventItemQuery } from '../EventPage/EventItem.queries.generated'
import type { EventItemViewFragment } from '../EventPage/EventItemView.fragment.generated'

import styles from './AttendeesActionsCard.module.css'

type Props = {
    entity: EventItemViewFragment
    viewer: EventItemQuery['viewer']
    site: SiteStoreState['site']
}

const AttendeesActionsCard = ({ entity, viewer, site }: Props) => {
    const { rsvp, attendEventWithoutAccount } = entity
    const { t } = useTranslation()

    const canAttendEvent =
        !entity.parent ||
        (entity?.parent?.requireAttendParent
            ? ['accept', 'online'].includes(entity?.parent?.isAttending)
            : true)

    return (
        <Card className={styles.wrapper}>
            {(rsvp || attendEventWithoutAccount) && (
                <div className="AttendeesWrapper">
                    <EventAttendees entity={entity} viewer={viewer} />

                    {canAttendEvent ? (
                        <EventAttend entity={entity} viewer={viewer} />
                    ) : (
                        <div className={styles.warning}>
                            {t('entity-event.parent-attendance-required')}
                        </div>
                    )}
                </div>
            )}
            <EventActions entity={entity} site={site} />
        </Card>
    )
}

export default AttendeesActionsCard
